module.exports = __webpack_public_path__ + "img/leaf2.b433a91a.png";